import * as angular from "angular";
import {IController} from "angular";
import {ClientRegistrationResponse} from "../../models/client-registration-response.model";
import {QuickbooksRegistrationStatus} from "../../models/quickbooks-registration-status.model";
import {IntegrationsRequestsService} from "../../services/integrations-requests.service";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";

export class QuickbooksIntegrationController implements IController {

  clientRegistration: ClientRegistrationResponse;
  registrationStatus: QuickbooksRegistrationStatus;

  constructor(private splitService,
              private $log,
              private confirmDialogService: ConfirmDialogService,
              private bringozLoaderService: BringozLoaderService,
              private integrationsRequestsService: IntegrationsRequestsService) {}

  connect() {
    const authorizationUrl = this.buildAuthorizationUrl(this.clientRegistration);
    location.replace(authorizationUrl);
  }

  disconnect() {
    this.confirmDialogService.confirm('Disconnect', 'Are you sure you want to disconnect from Quickbooks?')
      .then(() => {

        const siteId: string = this.splitService.getSiteId();
        const registrationId: string = this.registrationStatus.registrationId;

        this.bringozLoaderService.on();

        this.integrationsRequestsService.unRegisterQuickbooks(siteId, registrationId)
          .then((registrationStatus) => {
            this.registrationStatus = registrationStatus;
          })
          .finally(() => {
            this.bringozLoaderService.off();
          });
      })
      .catch(() => {
        this.$log.debug('Closed Dialog');
      });
  }

  //TODO: Move to service
  private buildAuthorizationUrl(clientRegistration: ClientRegistrationResponse): string {
    const scope = encodeURIComponent(clientRegistration.scopes.join(' '));
    const redirectUri = encodeURIComponent(clientRegistration.redirectUri);
    const csrfToken = encodeURIComponent(this.splitService.getSiteId() + '_' + Math.random().toString(36).substr(2));
    return `${clientRegistration.authorizationUri}?client_id=${clientRegistration.clientId}&response_type=code&scope=${scope}&redirect_uri=${redirectUri}&state=${csrfToken}`;
  }

}

angular
  .module('bringoz.admin.integrations')
  .component('quickbooksIntegration', {
    bindings: {
      clientRegistration: '<',
      registrationStatus: '<'
    },
    template: require('./quickbooks-integration.html').default,
    controller: QuickbooksIntegrationController
  });
